<script>
import {
  ServicePackageCardElementMixin,
} from "%/dynamic-component-editor/standard-components/service-package-card/service-package-card-element-mixin";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";

export default {
  name: "ServicePackageDescription",
  elementPanelSettings: {
    displayName: "Description",
    displayIcon: "text-alt",
    elementGroup: "servicePackageElements",
    elementType: "element",
  },
  extends: TextElement,
  mixins: [ServicePackageCardElementMixin],
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  computed: {
    isEditable() {
      return false;
    },
    value() {
      return this.entity.description;
    },
  },
};
</script>
